export const PROD_URL = 'app.hirenimble.com';
export const STAGING_URL = 'dev.hirenimble.com';
export const LOCAL_URL = 'localhost';
export const CONNECT_URL = '/connect';

export const SESSION_STORAGE_KEYS = {
  DISMISSED_BANNERS: 'dismissedBanners',
};

export const NAVBAR_BUTTON_LABELS = {
  LOGIN: 'Login',
  SIGN_UP: 'Sign up',
  DESKTOP_SUPPORT: 'Get Support',
  MOBILE_SUPPORT: 'Support',
};

export const PRODUCT_TIER = {
  ATS_LITE: 'ats_lite',
  ATS_FULL: 'ats_full',
  POSTING_ONLY: 'posting_only',
};

export const SUPPORTED_DISCOVER_STATES = {
  IN: 'indiana',
  MO: 'missouri',
  TN: 'tennessee',
  AR: 'arkansas',
  OK: 'oklahoma',
} as const;

export type SupportedDiscoverStateCode = keyof typeof SUPPORTED_DISCOVER_STATES;

export const QUERY_PARAMS = {
  FROM_HIRE: 'from_hire',
} as const;
